/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Model_Fable_Plan_Feat3Inputs */

const en_model_fable_plan_feat3 = /** @type {(inputs: Model_Fable_Plan_Feat3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto mode: Fable for the first draft, cheaper models for the rest`)
};

const id_model_fable_plan_feat3 = /** @type {(inputs: Model_Fable_Plan_Feat3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mode Auto: Fable untuk draf pertama, model hemat untuk sisanya`)
};

/**
* | output |
* | --- |
* | "Auto mode: Fable for the first draft, cheaper models for the rest" |
*
* @param {Model_Fable_Plan_Feat3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const model_fable_plan_feat3 = /** @type {((inputs?: Model_Fable_Plan_Feat3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Model_Fable_Plan_Feat3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_model_fable_plan_feat3(inputs)
	return en_model_fable_plan_feat3(inputs)
});